import React, { Component } from "react";
import { interval, from } from "rxjs";
import { map, switchMap, filter, take } from "rxjs/operators";

import * as overrideStages from "../model/lighting-overrides/overrideStageKeys";
import mapOverrideStage from "../model/lighting-overrides/mapOverrideStage";
import overrideTerminalStages from "../model/lighting-overrides/overrideTerminalStages";
import apiProxy from "../api/apiProxy.js";
import { withToastManager } from "../components/WithToastManager";

const OverrideToastContext = React.createContext();

class OverrideToastProviderBase extends Component {
  count = 0;

  overridesToMonitor = [];

  monitorOverrideStage = (overrideId, overrideName) => {
    // Don't set up a new monitor for an override which is already being monitored
    if (this.overridesToMonitor.includes(overrideId)) {
      return;
    }

    this.overridesToMonitor.push(overrideId);

    interval(30000)
      .pipe(
        switchMap(() => from(apiProxy.override.getOverrideStage(overrideId))),
        map(result => mapOverrideStage(result)),
        filter(mappedResult => overrideTerminalStages.includes(mappedResult)),
        take(1)
      )
      .subscribe(result => {
        this.overridesToMonitor = this.overridesToMonitor.filter(
          o => o !== overrideId
        );
        this.addOverrideToast(result, overrideName);
      });
  };

  addOverrideToast = (overrideStage, overrideName) => {
    switch (overrideStage) {
      case overrideStages.COMPLETED:
        this.props.toastManager.addToast({
          type: "success",
          label: "Override sent to store",
          message: `${overrideName} has been successfully sent to the store.`
        });
        break;
      case overrideStages.DISCARDED:
        this.props.toastManager.addToast({
          type: "success",
          label: "Override discarded",
          message: `${overrideName} has been discarded from the store.`
        });
        break;
      case overrideStages.FAILED:
        this.props.toastManager.addToast({
          type: "error",
          label: "Override failed",
          message: `${overrideName} failed to reach the store.`
        });
        break;
      case overrideStages.DISCARD_FAILED:
        this.props.toastManager.addToast({
          type: "error",
          label: "Override discard failed",
          message: `${overrideName} failed to discard from the store.`
        });
        break;
      default:
        break;
    }
  };

  render() {
    const overrideContext = {
      addToast: this.props.toastManager.addToast,
      monitorOverrideStage: this.monitorOverrideStage
    };

    return (
      <OverrideToastContext.Provider value={overrideContext}>
        {this.props.children}
      </OverrideToastContext.Provider>
    );
  }
}

export const OverrideToastProvider = withToastManager(OverrideToastProviderBase);

export default OverrideToastContext;
